import {
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { AuditTrailService } from 'src/app/core/services/audit-trail.service';

@Component({
    selector: 'app-audit-trail',
    templateUrl: './audit-trail.component.html',
    styleUrl: './audit-trail.component.scss',
    standalone: false
})
export class AuditTrailComponent {
  constructor(private auditTrailService: AuditTrailService) { }

  auditTrailData: any = {};
  @Output() download = new EventEmitter<void>();

  ngOnInit() {
    this.getAuditTrail();
  }

  getAuditTrail() {
    this.auditTrailService.getAuditTrailData().subscribe((res: any) => {
      this.auditTrailData = res;
    })
  }


  // @ViewChild('pdfContent')
  // pdfContent!: ElementRef;

  // downloadPdf() {
  //   this.auditTrailService.download(
  //     this.pdfContent.nativeElement,
  //     'invoice.pdf'
  //   );
  // }

}
